/* eslint-disable no-mixed-spaces-and-tabs */
import { useCallback } from "react";
import { ToastClose } from "@/components/ui/toast";
import { useToast } from "@/components/ui/use-toast";

export default function useDebugger() {
  const debugEnabled = import.meta.env.VITE_WAYFINDING_ENABLE_DEBUG === "true";
  const { toast } = useToast();

  const throwDebug = useCallback(
    ({
      message,
      success,
      error,
    }: {
      message: string;
      success?: boolean;
      error?: boolean;
    }) => {
      if (message && debugEnabled) {
        console.log("DEBUG:", message);
        toast({
          duration: 10000,
          title: `${message}`,
          description: `${new Date().toLocaleTimeString()}`,
          variant: success ? "primary" : error ? "destructive" : "default",
          action: (
            <ToastClose aria-label="Close">
              <span aria-hidden>×</span>
            </ToastClose>
          ),
        });
      }
    },
    [toast, debugEnabled],
  );

  return [throwDebug];
}
